module.exports = __webpack_public_path__ + "static/media/coin.3fb9b0be.svg";